var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_admin_leaveBalance_list_title"),
      pad: "0",
      filterable: "",
      exportBtn:
        _vm.selectOneStaff &&
        _vm.hasBtn("export-admin-leave-transaction") &&
        _vm.curTab == "tab-2",
      importBtn:
        _vm.hasBtn("import-admin-leave-transaction") &&
        Number(_vm.clientMode) !== 2,
      "import-options": {
        api: "/leave-transaction-record/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/leave-transaction-record-import-template.xlsx",
        success: function (result) {
          _vm.selectOneStaff = null
        },
      },
    },
    on: {
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  if (prop == "department") {
                    _vm.curDept = value
                  } //触发岗位更新下拉
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "transparent d-flex flex-row rounded-lg",
                attrs: { elevation: "0" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "fill-height white rounded-lg pa-0",
                    style: {
                      minHeight:
                        _vm.$vuetify.breakpoint.height - 238 + 42 - 48 + "px",
                    },
                    attrs: { elevation: "0", width: "280" },
                  },
                  [
                    _vm.show_Staff.length == 0 && !_vm.staff_Loading
                      ? _c("noContent")
                      : _vm._e(),
                    _vm.staff_Loading
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-center d-flex align-center justify-center",
                            style: {
                              minHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                size: "30",
                                width: "2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.staff_Loading
                      ? _c(
                          "v-list",
                          {
                            staticClass: "scroll_content_y",
                            style: {
                              maxHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                            attrs: { dense: "" },
                          },
                          [
                            _c(
                              "v-list-item-group",
                              {
                                attrs: { color: "primary" },
                                model: {
                                  value: _vm.selectOneStaff,
                                  callback: function ($$v) {
                                    _vm.selectOneStaff = $$v
                                  },
                                  expression: "selectOneStaff",
                                },
                              },
                              _vm._l(_vm.show_Staff, function (staff, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: "staff---" + index,
                                    staticClass: "pa-0 px-2 ma-0",
                                    attrs: {
                                      dense: "",
                                      "two-line": "",
                                      value: staff.staff_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-avatar",
                                      {
                                        staticClass: "pa-0 ma-0 mr-2",
                                        attrs: { size: "36" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            size: "36",
                                            src: staff.staff_avatar,
                                            staff_name: staff.preferred_name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption-xs",
                                              },
                                              [_vm._v(_vm._s(staff.staff_code))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.job_post_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "ml-3 rounded-lg flex-grow-1",
                    style: {
                      maxWidth: "calc(100% - 292px)",
                    },
                    attrs: { elevation: "0" },
                  },
                  [
                    _c("Taber", {
                      attrs: {
                        special: "",
                        backgroundColor: "white",
                        curTab: _vm.curTab,
                        items: _vm.taber,
                      },
                      on: {
                        change: function (tab) {
                          return (_vm.curTab = tab)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "content-1",
                          fn: function () {
                            return [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.BalanceHeaders,
                                  items: _vm.BalanceDeserts,
                                  type: "leavebalance",
                                  "content-class": "px-4 py-0",
                                  height:
                                    _vm.$vuetify.breakpoint.height -
                                    335 -
                                    48 +
                                    16,
                                  totalCount: _vm.totalCount1,
                                },
                                on: {
                                  change: function (page, perpage, callback) {
                                    _vm.getDetail(
                                      _vm.selectOneStaff,
                                      page,
                                      perpage,
                                      callback
                                    )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.leave_type_name",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.unit",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.unit == "D"
                                                    ? _vm.$t(
                                                        "label_essweb_system_dayLabel"
                                                      )
                                                    : item.unit == "H"
                                                    ? _vm.$t(
                                                        "label_essweb_system_hourLabel"
                                                      )
                                                    : _vm.$t(
                                                        "label_essweb_system_minutesLabel"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_brought_forward",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_brought_forward,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_entitlement",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_entitlement,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_earned",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_earned,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_taken",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_taken,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_balance,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_pending",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_pending,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_future_balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_future_balance,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_adjustment",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_adjustment,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_forfieted",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_forfieted,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_encashed",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_encashed,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_accrued",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_accrued,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm.hasBtn(
                                          "view-admin-leave-balance"
                                        ) && _vm.clientMode == 2
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toView(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "24",
                                                    fill: "currentColor",
                                                    iconClass: "viewDetail",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content-2",
                          fn: function () {
                            return [
                              _vm.clientMode != 2 && _vm.selectOneStaff
                                ? _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "d-flex justify-end px-4 mb-n4",
                                    },
                                    [
                                      _vm.hasBtn("add-admin-leave-transaction")
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "text-capitalize",
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showNewTran = true
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_leaveBalance_form_dialog_addLeaveTransactionBtnLabel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("add")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.TransactionHeaders,
                                  height:
                                    _vm.$vuetify.breakpoint.height -
                                    335 -
                                    48 -
                                    (_vm.clientMode != 2 ? 0 : 24),
                                  items: _vm.TransactionDeserts,
                                  type: "leavebalance",
                                  totalCount: _vm.totalCount2,
                                },
                                on: {
                                  change: function (page, perpage, callback) {
                                    _vm.getTransaction(
                                      _vm.selectOneStaff,
                                      page,
                                      perpage,
                                      callback
                                    )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.swift_id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.swift_number) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.tr_type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_transaction_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.start_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.start_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--secondary table-subtitle",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.start_utc_datetime,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.effect_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.effective_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.expiry_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.expired_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.unit",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.unit == "D"
                                                    ? _vm.$t(
                                                        "label_essweb_system_dayLabel"
                                                      )
                                                    : item.unit == "H"
                                                    ? _vm.$t(
                                                        "label_essweb_system_hourLabel"
                                                      )
                                                    : _vm.$t(
                                                        "label_essweb_system_minutesLabel"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.total",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "table-title",
                                            class:
                                              Number(item.total_minutes) > 0
                                                ? "green--text"
                                                : Number(item.total_minutes) < 0
                                                ? "red--text"
                                                : "text--primary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  Number(item.total_minutes) > 0
                                                    ? "+"
                                                    : Number(
                                                        item.total_minutes
                                                      ) < 0
                                                    ? ""
                                                    : ""
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.total_minutes,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.status",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("StatusChip", {
                                          attrs: {
                                            slideColor:
                                              item.status_value == "1"
                                                ? "orange"
                                                : item.status_value == "2" ||
                                                  item.status_value == "3" ||
                                                  item.status_value == "4"
                                                ? "grey"
                                                : item.status_value == "0" ||
                                                  item.status_value == "5" ||
                                                  item.status_value == "6"
                                                ? "green"
                                                : "currentColor",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "status",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            item.status_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm.hasBtn(
                                          "view-admin-leave-transaction"
                                        )
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { small: "", icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.detailUuid = item.uuid
                                                    _vm.showViewTran = true
                                                  },
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "24",
                                                    fill: "currentColor",
                                                    iconClass: "viewDetail",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("normalDialog", {
              attrs: {
                dialog: _vm.showDelete,
                deleteModel: "",
                title: _vm.$t("label_essweb_admin_leaveBalance_list_title"),
              },
              on: {
                close: function ($event) {
                  _vm.showDelete = false
                },
                confirm: _vm.toDelete,
              },
            }),
            _c("newTransactions", {
              attrs: {
                show: _vm.showNewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
              },
              on: {
                close: function ($event) {
                  _vm.showNewTran = false
                },
                onNew: _vm.onNewTransaction,
              },
            }),
            _c("viewTransactions", {
              attrs: {
                show: _vm.showViewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
                detailUuid: _vm.detailUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showViewTran = false
                  _vm.detailUuid = null
                },
              },
            }),
            _c("viewLeaveBalance", {
              ref: "detailAdminBalance",
              attrs: { headers: _vm.BalanceHeaders },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }